import {Entry, EntrySys, EQRResult, JSONSchema, TResponseFetchQR} from "../types/QRTypes";

export function useVariableQR() {
  const isBrowser = typeof window !== "undefined";

  const getItem = (key, defaultValue) => {
    return isBrowser ? localStorage.getItem(key) ?? defaultValue : defaultValue;
  };

  return {
    CONTENTFUL_ACCESS_TOKEN: getItem(
      "CONTENTFUL_ACCESS_TOKEN",
      "qrCD_gtiCb42gBBnEIfBvlYkQ9jX9CgGwST0Gczx2Ns"
    ),
    CONTENTFUL_SPACE_ID: getItem("CONTENTFUL_SPACE_ID", "bdj0rlksezwc"),
    CONTENTFUL_ENVIRONMENT_ID: getItem("CONTENTFUL_ENVIRONMENT_ID", "master"),
    CONTENTFUL_HOST: getItem("CONTENTFUL_HOST", "cdn.contentful.com"),
    AUTO_REDIRECT: getItem("AUTO_REDIRECT", true),
  };
}

export async function fetchShortLink(shortLink: string, locale:string): Promise<JSONSchema> {
  const {
    CONTENTFUL_ACCESS_TOKEN,
    CONTENTFUL_SPACE_ID,
    CONTENTFUL_ENVIRONMENT_ID,
    CONTENTFUL_HOST,
  } = useVariableQR();

  const url = new URL(
    `https://${CONTENTFUL_HOST}/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENVIRONMENT_ID}/entries`
  );

  url.searchParams.set("content_type", "shortLink");
  url.searchParams.set("fields.slug", shortLink);
  url.searchParams.set("include", "10");
  // url.searchParams.set("limit", "1");
  url.searchParams.set("locale", locale);

  const response = await fetch(url, {
    headers: {
      Authorization: `Bearer ${CONTENTFUL_ACCESS_TOKEN}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Contentful request failed: ${response.status}`);
  }

  return response.json();
}

export function getContent(responseJSON: JSONSchema) {
  
  const data = responseJSON.items?.[0].fields ?? null;

  const response: TResponseFetchQR = {
    data: null,
    status: EQRResult.NONE,
  };

  if (data != null) {
    if ("file" in data && data.file != null) {
      response.status = EQRResult.HAS_FILE;
      response.data = data.file.sys;

      return response;
    }

    if ("entry" in data && data.entry != null) {
      response.status = EQRResult.HAS_LINK;
      response.data = data.entry.sys;

      return response;
    }

    if ("externalUrl" in data && data.externalUrl != null) {
      response.status = EQRResult.HAS_EXTERNAL_LINK;
      response.data = data.externalUrl;

      return response;
    }
  }

  return response;
}

export async function getFile(fileId: string) {
  
  const {
    CONTENTFUL_ACCESS_TOKEN,
    CONTENTFUL_SPACE_ID,
    CONTENTFUL_ENVIRONMENT_ID,
    CONTENTFUL_HOST,
  } = useVariableQR();


  const url = new URL(
    `https://${CONTENTFUL_HOST}/spaces/${CONTENTFUL_SPACE_ID}/environments/${CONTENTFUL_ENVIRONMENT_ID}/assets/${fileId}`
  );

  const responseFile = await fetch(url, {
    headers: {
      Authorization: `Bearer ${CONTENTFUL_ACCESS_TOKEN}`,
    },
  });

  if (!responseFile.ok) {
    throw new Error(`Contentful request failed: ${responseFile.status}`);
  }

  const result = await responseFile.json();
  return `https:${result?.fields.file.url}`;
}

export function getParentChain(response: JSONSchema) {
  
  const entries = [...(response.items ?? []), ...(response.includes?.Entry ?? [])];

  const entriesById = new Map(entries.map((entry) => [entry.sys.id, entry]));

  const shortLink = response.items?.[0];
  const referenceId = shortLink?.fields?.entry?.sys?.id;

  const chain = [];
  const visited = new Set();

  let current = entriesById.get(referenceId);

  while (current) {
    if (visited.has(current.sys.id)) {
      throw new Error(`Circular reference detected: ${current.sys.id}`);
    }

    visited.add(current.sys.id);
    chain.push(current);

    const parentId = current.fields?.parentPage?.sys?.id;

    if (!parentId) {
      break;
    }

    current = entriesById.get(parentId);

    if (!current) {
      console.warn(`Parent ${parentId} was not included`);
      break;
    }
  }

  return chain.map(c=>c.fields.slug).reverse().join("/").substring(1);
}
